//@ts-check
import $ from 'jquery';
import _ from 'lodash';

const tags = '([/]?)(p|h2|ul|ol|blockquote|li|strong|em|del|strike|br|a|sd-embed)';

const htmlRegEx = new RegExp('<' + tags + '>', 'gi');
const markdownRegex = new RegExp('{' + tags + '}', 'gi');
const embedHtmlRegex = /<(sd-embed([^>]+))>/gi;
const anchorHtmlRegex = /<(a([^>]+))>/gi;
const anchorMarkdownRegex = /{(a([^}]+))}/gi;
const embedMarkdownRegex = /{(sd-embed([^}]+))}/gi;
const specialEntityHtmlRegex = /{*&(nbsp|gt|lt);}*/gi;
const specialEntityMarkDownRegex = /{&(nbsp|gt|lt);}/gi;
const escapeCharacter = String.fromCharCode(27);
const innocuousTags =
    'html, body, div, span, section, article, u, pre, sub, sup, font, center, thead, tbody, tfoot, tr, th, td'; //eslint-disable-line max-len
const supportedTags = 'p, ul, ol, li, h2, blockquote, a[href], br, strong, em, strike, sd-embed[data-embed-type]';
const blockTags = 'p, blockquote, ol, ul, h2';
const invalidlyNestedTags = 'p p, strong strong, em em';
const headings = 'h1, h3, h4, h5, h6';
const replacementTags = {
    b: 'strong',
    i: 'em',
    s: 'strike',
    del: 'strike',
    q: 'blockquote',
    bq: 'blockquote',
    eb: 'sd-embed',
};

export const decodeEntities = (ignoredEntities, text) => {
    const $decoder = $('<div/>');
    const regex = /(&[^;]+;)/gi;

    if (ignoredEntities.length) {
        return text.replace(regex, match => {
            const index = ignoredEntities.indexOf(match);
            return index === -1 ? $decoder.html(match).text() : ignoredEntities[index];
        });
    }

    return text.replace(regex, match => {
        return $decoder.html(match).text();
    });
};

const htmlTidier = {
    $el: '',
    // CURRENTLY CREATED AN sd-embed ELEMENT, SHOULD PROB CHANGE TO A ARTICLE ONCE READY
    $p: $('<p/>'),
    $div: $('<div/>'),
    cleanText(text) {
        return text
            .replace(new RegExp(escapeCharacter, 'gi'), '')
            .replace(/\n/gi, '')
            .replace(/\r/gi, '');
    },
    replaceWithContents() {
        return $(this).html();
    },
    safelyReplaceWithContents() {
        return $(this).text();
    },
    removeAttributes() {
        const $el = $(this);
        const tagName = $el[0].tagName;

        return $(`<${tagName}/>`).html($el.html());
    },
    replaceTable() {
        const container = htmlTidier.$div.clone();
        const $p = htmlTidier.$p;

        $(this)
            .find('th, td')
            .each(function () {
                $p.clone()
                    .html($(this).html())
                    .appendTo(container);
            });
        return container.html();
    },
    replaceElement(replacement, orig) {
        const newTag = $(`<${replacement}/>`);

        this.find(orig).replaceWith(function () {
            return newTag.clone().html($(this).html());
        });
    },
    replaceHeading() {
        return $('<h2/>').html($(this).html());
    },
    cleanLink() {
        const $el = $(this);
        const target = $el.attr('target');
        const title = $el.attr('title');
        const $newEl = $('<a/>')
            .attr('href', $el.attr('href'))
            .html($el.html());

        if (target) {
            $newEl.attr('target', target);
        }
        if (title) {
            $newEl.attr('title', title);
        }

        return $newEl;
    },
    cleanCaption() {
        const $el = $(this);
        const $newEl = $el.clone();
        const embedFile = $newEl.attr('data-embed-file');
        if (embedFile){
            const cleanFile = embedFile ? decodeURI(embedFile).replace(/p\s*\/p/gi, '') : embedFile;
            $newEl.attr('data-embed-file', encodeURI(cleanFile));
        }
        return $newEl;
    },
    fixNestedLists() {
        const $el = $(this);
        $el.parent('p').after($el);
    },
    wrapOrphans($contents) {
        let orphans = [$('')];
        let $orphanGroup = orphans[0];

        $contents.each(function () {
            const $el = $(this);

            if ($el.is(blockTags)) {
                $orphanGroup = orphans[orphans.push($('')) - 1];
            } else {
                $orphanGroup.append($el);
            }
        });

        orphans = _.filter(orphans, function ($group) {
            return $group.length > 0;
        });

        _.each(orphans, function ($group) {
            $group.wrap($('<p/>'));
        });

        return $contents;
    },
    tidy(html, wrapOrphans) {
        // eslint-disable-line max-statements

        const $el = this.$div.clone().html(this.cleanText(html));
        _.each(replacementTags, this.replaceElement.bind($el));

        $el.find('a[href^="http"], a[href^="//"]').attr('target', '_blank');
        $el.find(invalidlyNestedTags).replaceWith(this.replaceWithContents);
        $el.find('p > ul, p > ol').each(this.fixNestedLists);
        $el.find('ul, ol')
            .find(blockTags)
            .replaceWith(this.replaceWithContents);
        $el.find('table').replaceWith(this.replaceTable);
        $el.find('div div').replaceWith(function () {
            return htmlTidier.$p.clone().html($(this).html());
        });
        $el.find('p')
            .find(blockTags)
            .replaceWith(this.safelyReplaceWithContents);
        $el.find('p li').replaceWith(this.replaceWithContents);
        try {
            $el.find(innocuousTags).replaceWith(this.safelyReplaceWithContents);
        } catch (e) {
            // some html is too foobar for this to handle
            console.warn('some HTML could not be converted');
            $el.find(innocuousTags).remove();
        }
        $el.find(headings).replaceWith(this.replaceHeading);
        $el.find('*')
            .not(supportedTags)
            .remove();

        $el.find(supportedTags)
            .not('a[href]')
            .not('sd-embed[data-embed-type]')
            .replaceWith(this.removeAttributes);

        $el.find('sd-embed[data-embed-type]')
            .replaceWith(this.cleanCaption);

        $el.find('a[href]').replaceWith(this.cleanLink);


        // strip html comments
        $el.contents()
            .filter(function () {
                return this.nodeType === Node.COMMENT_NODE;
            })
            .remove();

        if (wrapOrphans !== false) {
            $el.html(this.wrapOrphans($el.contents()));
        }

        // magic sauce to remove inline styles which appear somewhere above.
        $el.find('[style]').removeAttr('style');

        return decodeEntities(['&nbsp;', '&gt;', '&lt;'], $el.html());
    },
};

export const cleanText = text => htmlTidier.cleanText(text);

export const tidy = html => htmlTidier.tidy(html);

//:: html -> markdown
export const stringify = html =>
    tidy(html)
        .replace(htmlRegEx, '{$1$2}')
        .replace(anchorHtmlRegex, '{$1}')
        .replace(embedHtmlRegex, '{$1}')
        .replace(specialEntityHtmlRegex, '{&$1;}')
        .replace(htmlRegEx, '');

/**
 * @param {string} markdown
 * @returns {string} encoded html
 */
export const parse = markdown =>
    markdown
        .replace(markdownRegex, '<$1$2>')
        .replace(anchorMarkdownRegex, '<$1>')
        .replace(embedMarkdownRegex, '<$1>')
        .replace(specialEntityMarkDownRegex, '&$1;');

export const textToHTML = text => ['<p>', text.split('\n\n').join('</p><p>'), '</p>'].join('');

export const isMarkdown = text => markdownRegex.test(text);

export const isHTML = text => /<([^>]+)>/gi.test(text);

export const addStory = ($el, story) => $el.html(htmlTidier.tidy(parse(story)));
